import constants from 'constants';

const {
  START_REQUEST,
  END_REQUEST
} = constants;

const requests = (requests = [], action) => {
  switch(action.type) {
    case START_REQUEST:
      return [
        ...requests,
        action.payload.request
      ]
    case END_REQUEST:
      return requests.filter(request => request != action.payload.request)
    default:
      return requests;
  }
}

export { requests };



// WEBPACK FOOTER //
// ./src/reducers/requests.js